export const WebsiteName: string = "shadoer"
export const WebsiteBaseUrl: string = "https://shadoer.com"
export const WebsiteDescription: string = "call more and call better"
export const CreateProfileStep: boolean = true
export const API_BASE = import.meta.env.PROD 
  ? "https://api.tamouri.com"  // Production
  : "/external-api"            // Development (proxied)

export const POLLING_INTERVAL = import.meta.env.PROD
  ? 60_000
  : 15_000
